import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Sanitizer,
  ViewChild,
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { Alert } from '@classes/alert/alert';
import { Waste } from '@classes/waste/waste';
import { environment } from '@environments/environment';
import { LicenseService } from '@services/anpr/license.service';
import { mediaService } from '@services/media/media.service';
import { NotificationService } from '@services/notifications/notification.service';
import { UserService } from '@services/user/user.service';
import { Router } from '@angular/router';

const reader = new FileReader();
export interface DialogData {
  alert: Alert;
  index: number;
  length: number;
  safeUrl: any;
}

@Component({
  selector: 'app-video-waste',
  templateUrl: './video-waste.component.html',
  styleUrls: ['./video-waste.component.scss'],
})
export class VideoWasteComponent implements OnInit {
  @ViewChild('videoElement') public videoElement: ElementRef;
  // @Input('snapshotName') public snapshotName: string;
  @Input('downloadImageType') public userImageType: string;
  waste: Waste;
  link: any;
  url: any;
  media: string;
  safeUrl: any;
  loading: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressBarMode = 'indeterminate';
  value = 50;
  bufferValue = 75;
  canUseAnpr: boolean;
  isLoading: boolean;

  public snapshotName: string = 'sample_snapshot';
  public snapshotImageType: string = 'JPG';
  public imageTypes = [
    'JPG',
    'PNG',
    'BMP',
    'TIFF',
    'GIF',
    'PPM',
    'PGM',
    'PBM',
    'PNM',
    'WebP',
    'HEIF',
    'BPG',
    'ECW',
    'FITS',
    'FLIP',
    'PAM',
    'CD5',
    'CPT',
    'PSD',
    'PSP',
    'XCF',
    'PDN',
  ];
  constructor(
    private mediaService: mediaService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private sanitizer: DomSanitizer,
    private notificationService: NotificationService,
    private userService: UserService,
    private licenseService: LicenseService,
    public dialogRef: MatDialogRef<VideoWasteComponent>,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    // this.initComponent();
    this.isLoading = false;
    this.checkAnpr();
    this.getMediaById();

    // this.getLink();
  }

  getMediaById(): void {
    this.data.alert?.medias?.forEach((t) => {
      this.fetch(t.id);
    });
  }

  private fetch(id) {
    const video = this.data.alert.medias.find((m) => m.type === 'Video');

    // ----- ATTENTION : à décommenter pour le déploiement ------
    this.url = `${environment.apiUrl}/medias/${video.id}/file`;
    // this.url = 'assets/videos/anpr_test.mp4';
  }
  public takeSnapshot() {
    const canvasElement = <HTMLCanvasElement>document.createElement('CANVAS');
    const video = this.videoElement.nativeElement;
    const context = canvasElement.getContext('2d');
    let w: number, h: number, ratio: number;
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth - 100;
    h = w / ratio;
    canvasElement.width = w;
    canvasElement.height = h;
    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);
    const link = document.createElement('a');
    this.snapshotName =
      this.snapshotName !== '' ? this.snapshotName : 'miniature';
    this.userImageType =
      this.imageTypes.indexOf(this.userImageType) >= 0
        ? this.userImageType
        : 'PNG';
    link.setAttribute('download', this.snapshotName + '.' + this.userImageType);
    const dataURL = canvasElement.toDataURL();

    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
  }

  public checkAnpr(): void {
    let client = this.userService.clientSelected;
    this.licenseService.getClientLicense(client).subscribe((res) => {
      if (typeof res !== 'undefined' && res.status.name == 'Active') {
        this.canUseAnpr = true;
      } else {
        this.canUseAnpr = false;
      }
    });
  }

  public onClickAnpr() {
    this.isLoading = true;
    const canvasElement = <HTMLCanvasElement>document.createElement('CANVAS');
    const video = this.videoElement.nativeElement;
    const context = canvasElement.getContext('2d');
    let w: number, h: number, ratio: number;
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth;
    h = w / ratio;
    canvasElement.width = w;
    canvasElement.height = h;
    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);
    var imageBase64 = canvasElement.toDataURL();
    this.snapshotName =
      this.snapshotName !== '' ? this.snapshotName : 'miniature';
    this.userImageType =
      this.imageTypes.indexOf(this.userImageType) >= 0
        ? this.userImageType
        : 'PNG';
    var file = this.licenseService.dataUrlToFile(
      imageBase64,
      this.snapshotName + '.' + this.userImageType
    );
    this.licenseService.useAnpr(file).subscribe((res) => {
      this.router.navigate(['/smartwaste/ANPR']);
      this.dialog.closeAll();
    });
  }
}
